import React, { useReducer } from 'react';

const initialState = { backgroundColor: 'white' };

const reducer = (
	state: { backgroundColor: string },
	action: 'blue' | 'red',
): { backgroundColor: string } => {
	console.log('state', state);

	switch (action) {
		case 'blue':
			return {
				backgroundColor: '#007bff',
			};
		case 'red':
			return {
				backgroundColor: 'red',
			};
		default:
			return {
				backgroundColor: '#fff',
			};
	}
};

function UserReducer() {
	const [state, dispatch] = useReducer(reducer, initialState);

	return (
		<>
			<div
				className={`w-12 h-12 rounded-md flex items-center justify-center  text-black`}
				style={{
					backgroundColor: state.backgroundColor,
				}}
			/>
			<div className="flex items-center gap-3">
				<button onClick={() => dispatch('red')}>Change Red</button>
				<button onClick={() => dispatch('blue')}>Change Blue</button>
			</div>
		</>
	);
}

export default UserReducer;
